// src/pages/doctors/DoctorsPage/CorrectionRequestsModal.js
import React, { useState, useEffect } from 'react';
import { Modal, Table, Tag, Button, Space, Typography, message } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
// Attention : ajustez le chemin d'import selon la structure de vos dossiers
import axiosInstance from '../../../services/axiosServicesVisit'; 
import dayjs from 'dayjs';

const { Text } = Typography;

const CorrectionRequestsModal = ({ visible, onClose }) => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(false);
    const [actionLoading, setActionLoading] = useState(null);

    const fetchPendingRequests = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get('/v1/data-corrections/pending/persons');
            setRequests(response.data);
        } catch (error) {
            message.error("Erreur lors du chargement des suggestions.");
        } finally {
            setLoading(false);
        }
    };

    // Charger les données uniquement quand le modal devient visible
    useEffect(() => {
        if (visible) {
            fetchPendingRequests();
        }
    }, [visible]);

    const handleAction = async (id, action) => {
        setActionLoading(id);
        try {
            await axiosInstance.post(`/v1/data-corrections/${id}/${action}`);
            message.success(`La suggestion a été ${action === 'approve' ? 'approuvée' : 'rejetée'}.`);
            fetchPendingRequests(); // Rafraîchir la liste après action
        } catch (error) {
            message.error("Une erreur est survenue.");
        } finally {
            setActionLoading(null);
        }
    };

    const columns = [
        {
            title: 'Date',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 120,
            render: (date) => dayjs(date).format('DD/MM/YYYY'),
        },
        {
            title: 'Délégué',
            key: 'delegate',
            render: (_, record) => `${record.submittedBy.firstname} ${record.submittedBy.lastname}`,
        },
        {
            title: 'Médecin',
            key: 'person',
            render: (_, record) => `${record.person.firstname} ${record.person.lastname}`,
        },
        {
            title: 'Champ',
            dataIndex: 'fieldName',
            key: 'fieldName',
            render: (field) => <Tag color="blue">{field}</Tag>,
        },
        {
            title: 'Suggéré',
            dataIndex: 'suggestedValue',
            key: 'suggestedValue',
            render: (value) => <Text strong style={{ color: '#52c41a' }}>{value}</Text>
        },
        {
            title: 'Actions',
            key: 'actions',
            fixed: 'right',
            width: 100,
            render: (_, record) => (
                <Space size="small">
                    <Button
                        type="primary"
                        icon={<CheckOutlined />}
                        onClick={() => handleAction(record.id, 'approve')}
                        loading={actionLoading === record.id}
                        size="small"
                    />
                    <Button
                        danger
                        icon={<CloseOutlined />}
                        onClick={() => handleAction(record.id, 'reject')}
                        loading={actionLoading === record.id}
                        size="small"
                    />
                </Space>
            ),
        },
    ];

    return (
        <Modal
            title="Suggestions de Correction (Médecins)"
            visible={visible}
            onCancel={onClose}
            footer={null} // Pas de bouton en bas, tout est dans le tableau
            width={1000} // Largeur augmentée pour le tableau
            destroyOnClose={true}
        >
            <Table
                columns={columns}
                dataSource={requests}
                loading={loading}
                rowKey="id"
                bordered
                size="small"
                scroll={{ x: 800 }} // Scroll horizontal si nécessaire
                pagination={{ pageSize: 5 }}
                locale={{ emptyText: 'Aucune suggestion en attente.' }}
            />
        </Modal>
    );
};

export default CorrectionRequestsModal;